import React from 'react';
import { useIntl } from 'react-intl';
import { Grid } from '@mui/material';
import FormSelect from '../../../../../Components/Form/FormSelect';
import FormRadioStack from '../../../../../Components/Form/FormRadioStack';
import keysToLowerCase from '../../../../../Helpers/keysToLowerCase';

const CallExtraParams = function CallExtraParams({
  errors,
  watch,
  defaultData = {},
  activityTypes,
}) {
  const intl = useIntl();
  const extensionData = keysToLowerCase(
    JSON.parse(defaultData?.extensionData || '{}')
  );
  const defaultValues = {
    ...extensionData,
    answered: extensionData?.answered,
    answeredSection: extensionData?.answeredSection,
    shouldSync: extensionData?.shouldSync,
  };

  const shouldSyncWatch = watch && watch('nextActType');

  return (
    <>
      <Grid size={6}>
        <FormRadioStack
          name="answered"
          options={[
            { label: 'ANSWERED', value: true },
            { label: 'NOT_ANSWERED', value: false },
          ]}
          row
          required
          error={errors?.answered}
          defaultValue={defaultValues.answered}
        />
      </Grid>
      <Grid size={6}>
        <FormRadioStack
          name="answeredSection"
          options={[
            { label: 'ANSWERED', value: true },
            { label: 'NOT_ANSWERED', value: false },
          ]}
          row
          required
          error={errors?.answeredSection}
          defaultValue={defaultValues.answeredSection}
        />
      </Grid>
      <Grid size={6}>
        <FormSelect
          name="sections"
          options={[
            { value: 'CUSTOMERS', label: intl.messages.CUSTOMERS },
            { value: 'BIRTHDAYS', label: intl.messages.BIRTHDAYS },
            { value: 'LIGHT', label: intl.messages.LIGHT },
            { value: 'PREMIUMBANK', label: intl.messages.PREMIUMBANK },
            { value: 'CORPORATE', label: intl.messages.CORPORATE },
            { value: 'SPOT', label: intl.messages.SPOT },
            { value: 'WELCOME', label: intl.messages.WELCOME },
            { value: 'DEALERS', label: intl.messages.DEALERS },
          ]}
          multiple
          required
          error={errors?.sections}
          defaultValue={defaultValues.sections || []}
        />
      </Grid>
      <Grid size={6}>
        <FormSelect
          name="nextActType"
          options={[
            { label: '- - -', value: '' },
            ...(activityTypes || []).map(({ id, name }) => ({
              label: intl.messages[name?.toUpperCase()] || name,
              value: id,
            })),
          ]}
          error={errors?.nextActType}
          defaultValue={defaultValues.nextActType}
        />
      </Grid>
      {shouldSyncWatch && (
        <Grid size={6}>
          <FormRadioStack
            name="shouldSync"
            row
            options={[
              { label: 'YES', value: true },
              { label: 'NO', value: false },
            ]}
            error={errors?.shouldSync}
            defaultValue={defaultValues.shouldSync}
          />
        </Grid>
      )}
    </>
  );
};
export default CallExtraParams;
